import React from 'react';
import { mainContent } from '../mockData';

const MainContent = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl lg:text-5xl font-bold text-[#0A1F3B] mb-6 leading-tight">
            {mainContent.title}
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            {mainContent.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default MainContent;